import React from 'react'
import PropTypes from 'prop-types'

import Modal from './Modal'


const ModalConfirm = ({
  open,
  title,
  onClose,
  onSubmit,
  children,
  isLoading,
  submitLabel = 'Confirmer',
}) => {
  return (
    <Modal
      open={open}
      title={title}
      onClose={onClose}
      isLoading={isLoading}
      cancelLabel="Retour"
      onCancel={onClose}
      submitLabel={submitLabel}
      onSubmit={onSubmit}
    >
      {children}
    </Modal>
  )
}


ModalConfirm.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  children: PropTypes.node.isRequired,
  submitLabel: PropTypes.string,
}


export default ModalConfirm
